import ConfirmDialog, {
  ConfirmDialogProps,
} from '@components/Dialogs/ConfirmDialog';
import { Modes } from '@constants/canvas/layers';
import { useProject } from '@context/Project/ProjectProvider';
import { FC } from 'react';

type Props = Pick<ConfirmDialogProps, 'open' | 'onClose' | 'title' | 'text'>;

const EmptyControlsModal: FC<Props> = (props) => {
  const { onClose, title, text } = props;
  const { handleModeChange } = useProject();

  const handleOpenControls = () => {
    onClose?.();
    handleModeChange(Modes.Controls);
  };

  return (
    <ConfirmDialog
      title={title}
      text={text}
      confirmName="Open controls mode"
      onConfirm={handleOpenControls}
      {...props}
    />
  );
};

export default EmptyControlsModal;
